import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

import { IBulletList } from '../../models/i-card';

@Component({
  selector: 'vantage-platform-bullet-list',
  templateUrl: './bullet-list.component.html',
  styleUrls: ['./bullet-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulletListComponent implements OnInit {
  @Input() data: IBulletList;

  constructor() {}

  ngOnInit(): void {}
}
